<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousAir" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Airline Booking Order</b-navbar-brand>
        </b-navbar>
        <banner-component :allModuleIdBanner="
            this.BookingShippingLine.allModuleId
              ? this.BookingShippingLine.allModuleId
              : ''
          " :jobSeriesBanner="
            this.BookingShippingLine.assignmentNumber
              ? this.BookingShippingLine.assignmentNumber
              : ''
          " :bannerClientName="
            this.allShipperData[0].clientName ? this.allShipperData[0].clientName : ''
          " iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <md-layout gutter>
              <!-- <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Enter Booking Number</label>
              <b-form-input :formatter="capitalizeAll"
                name="bookingNumber"
                id="bookingNumber"
                v-model="BookingShippingLine.bookingNumber"
              ></b-form-input>
            </md-layout>

            <span
              class="error"
              v-if="!BookingShippingLine.bookingNumber"
            >{{errorBooking.bookingNumber}}</span>
              </md-layout>-->

              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Assignment No.</label>
                  <b-form-input :formatter="capitalizeAll" name="assignmentNumber" id="assignmentNumber"
                    v-model="BookingShippingLine.assignmentNumber" disabled></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="40">
                <label>IATA Agent</label>
                <model-list-select option-value="agntColoaderId" option-text="agentName" :list="agentMasterList"
                  placeholder="Select IATA  Agent" v-model="BookingShippingLine.IATAAgent"></model-list-select>
                <span class="error" v-if="!BookingShippingLine.IATAAgent">{{
                  errorBookingShippingLine.IATAAgent
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Booking Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="bookingDate" name="bookingDate"
                  v-model="BookingShippingLine.bookingDate"></date-picker>
                <span class="error" v-if="!BookingShippingLine.bookingDate">{{
                  errorBookingShippingLine.bookingDate
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label>Airline Name</label>
                <model-list-select option-value="airlineId" :custom-text="codeAndNameAndDesc1" :list="airMasterList"
                  placeholder="Select Airline Name" v-model="BookingShippingLine.airLine"></model-list-select>
                <span class="error" v-if="!BookingShippingLine.airLine">{{
                  errorBookingShippingLine.airLine
                  }}</span>
              </md-layout>
            </md-layout>
            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  {{ BookingShippingLine.shipmentExecution }}
                  <label>MAWB No.(1234567890)</label>
                  <b-form-input :formatter="capitalizeAll" name="MAWBNumber" id="MAWBNumber"
                    v-model="BookingShippingLine.MAWBNumber" @keyup="
                      BookingShippingLine.shipmentExecution != 'Courier'
                        ? containerNoRegexfun
                        : ''
                    " :type="
                      BookingShippingLine.shipmentExecution != 'Courier'
                        ? 'number'
                        : 'text'
                    "></b-form-input>
                  <!-- BookingShippingLine.shipmentExecution=='Courier' ? -->
                </md-layout>
                <span class="error" v-if="!BookingShippingLine.MAWBNumber">{{
                  mawbError
                  }}</span>
                <span class="error" v-else-if="blRegexError != ''">{{
                  blRegexError
                  }}</span>
                <span class="error" v-if="!BookingShippingLine.MAWBNumber">{{
                  errorBookingShippingLine.MAWBNumber
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>MAWB Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="MAWBDate" name="MAWBDate"
                  v-model="BookingShippingLine.MAWBDate"></date-picker>
                <span class="error" v-if="!BookingShippingLine.MAWBDate">{{
                  errorBookingShippingLine.MAWBDate
                  }}</span>
              </md-layout>
            </md-layout>
            <md-layout gutter v-if="airFreightModel.airFFType == 'fclNormal'" class="labelMargtop">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Client Name</label>
                  <b-form-input :formatter="capitalizeAll" name="clientName" id="clientName"
                    v-model="BookingShippingLine.clientName" disabled></b-form-input>
                </md-layout>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30" v-if="clientList[0].typeAirway == 'HouseAirwayBL'">
                <md-layout md-flex="100">
                  <label>HAWB No.</label>
                  <b-form-input :formatter="capitalizeAll" name="HAWBNumber" id="HAWBNumber"
                    v-model="BookingShippingLine.HAWBNumber"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20" v-if="clientList[0].typeAirway == 'HouseAirwayBL'">
                <label>HAWB Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="HAWBDate" name="HAWBDate"
                  v-model="BookingShippingLine.HAWBDate"></date-picker>
              </md-layout>
            </md-layout>

            <md-layout gutter v-else-if="clientList.length > 0 || hawbModal.moreHawbId != ''" class="labelMargtop">
              <md-layout md-flex="40">
                <label for="clientId" v-if="hawbModal.moreHawbId == ''">Client Name</label>

                <model-list-select v-if="hawbModal.moreHawbId == ''" :list="clientList" id="clientNamenew"
                  v-model="hawbModal.shipperFreightId" option-value="shipperFreightId" option-text="clientName"
                  placeholder="Select  Client Name"></model-list-select>
                <md-layout md-flex="100" v-else>
                  <label for="clientId">Client Name</label>

                  <b-form-input :formatter="capitalizeAll" v-model="hawbModal.clientName" disabled></b-form-input>
                </md-layout>
                <span class="error" v-if="!hawbModal.shipperFreightId">{{
                  errorHawbModal.shipperFreightId
                  }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>HAWB No.</label>
                  <b-form-input :formatter="capitalizeAll" name="HAWBNumber" id="HAWBNumber"
                    v-model="hawbModal.HAWBNumber" @keyup="houseNoRegexfun" type="number"></b-form-input>
                </md-layout>
                <span class="error" v-if="!hawbModal.HAWBNumber">{{
                  errorHawbModal.HAWBNumber
                  }}</span>
                <span class="error" v-else-if="houseRegexError != ''">{{
                  houseRegexError
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>HAWB Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="HAWBDate" name="HAWBDate"
                  v-model="hawbModal.HAWBDate"></date-picker>
                <span class="error" v-if="!hawbModal.HAWBDate">{{
                  errorHawbModal.HAWBDate
                  }}</span>
                <!-- <span
              class="error"
              v-if="!BookingShippingLine.HAWBDate"
                >{{errorBookingShippingLine.HAWBDate}}</span>-->
              </md-layout>
              <md-layout md-flex="15" style="margin-top: 1%">
                <b-button variant="info" size="sm" @click="addHawbDetails" id="addButtonLoaderhawb"
                  style="margin-top: 38px">{{ hawbModal.moreHawbId == "" ? "Add HAWB" : "Edit HAWB" }}</b-button>
              </md-layout>
            </md-layout>
            <div class="box" v-if="HAWBArray.length > 0">
              <div class="box-header">
                <h3 class="box-title">HAWB Details</h3>
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="tableHawb" class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Client Name</th>
                      <th>HAWB No.</th>
                      <th>HAWB Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in HAWBArray" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td @click="viewEdithawb(item)" class="showMoreData">
                        {{ item.clientName }}
                      </td>
                      <td>{{ item.HAWBNumber }}</td>
                      <td>{{ item.HAWBDate | moment }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="40">
                <label for="Id">From Location</label>
                <model-list-select @input="getLocationList($event, 'Air_Port', 'fromPortList')"
                  @searchchange="getLocationList($event, 'Air_Port', 'fromPortList')" option-value="pickupId"
                  option-text="pickupLocation" :list="fromPortList" placeholder="Select Port Name"
                  v-model="BookingShippingLine.fromAirport"></model-list-select>
                <span class="error" v-if="!BookingShippingLine.fromAirport">{{
                  errorBookingShippingLine.fromAirport
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55">
                <label for="containerTypeId">To Location</label>
                <model-list-select @input="getLocationList($event, 'Air_Port', 'toPortList')"
                  @searchchange="getLocationList($event, 'Air_Port', 'toPortList')" option-value="pickupId"
                  option-text="pickupLocation" :list="toPortList" placeholder="Select Port Name"
                  v-model="BookingShippingLine.toAirport"></model-list-select>
                <span class="error" v-if="!BookingShippingLine.toAirport">{{
                  errorBookingShippingLine.toAirport
                  }}</span>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Flight Number</label>
                  <b-form-input :formatter="capitalizeAll" name="flightNumber" id="flightNumber"
                    v-model="BookingShippingLine.flightNumber"></b-form-input>
                </md-layout>
                <span class="error" v-if="!BookingShippingLine.flightNumber">{{
                  errorBookingShippingLine.flightNumber
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Departure Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="dateDeparture" name="dateDeparture"
                  v-model="BookingShippingLine.dateDeparture"></date-picker>
                <span class="error" v-if="!BookingShippingLine.dateDeparture">{{
                  errorBookingShippingLine.dateDeparture
                  }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Arrival Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="dateArrival" name="dateArrival"
                  v-model="BookingShippingLine.dateArrival"></date-picker>
                <span class="error" v-if="!BookingShippingLine.dateArrival">{{
                  errorBookingShippingLine.dateArrival
                  }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="40">
                <label for="bookingShipment">Booking Transhipment</label>
                <model-list-select option-value="bookingShipmentVal" option-text="bookingShipmentText"
                  :list="bookingShipmentList" placeholder="Select Booking Transhipment"
                  v-model="BookingShippingLine.bookingShipment"
                  :isDisabled="tentativeDetailArray.length == 0 ? false : true"></model-list-select>

                <span class="error" v-if="!BookingShippingLine.bookingShipment">{{
                  errorBookingShippingLine.bookingShipment
                  }}</span>

                <span class="error" v-if="
                    BookingShippingLine.bookingShipment == 'yes' &&
                    tentativeDetailArrayList.length == 0
                  ">{{ bookingLengthError }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="30">
                <b-button variant="outline-dark" size="sm" v-if="
                    BookingShippingLine.bookingShipment == 'yes' &&
                    this.lastTransID == false
                  " @click="showAddAirportmet">Click here to
                  {{ showAddAirport == false ? "Add " : "Hide" }} Transhipment</b-button>
              </md-layout>
            </md-layout>
            <b-card class="gutr" style="background: whiteSmoke" v-if="
                BookingShippingLine.bookingShipment == 'yes' || showAddAirport == true
              ">
              <div v-if="
                  BookingShippingLine.bookingShipment == 'yes' && showAddAirport == true
                " id="TranshipmentDetail">
                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="40">
                    <label for="containerTypeId">From Location</label>
                    <model-list-select @input="getLocationList($event, 'Air_Port', 'fromPortListTrans')" @searchchange="
                        getLocationList($event, 'Air_Port', 'fromPortListTrans')
                      " option-value="pickupId" option-text="pickupLocation" :list="fromPortListTrans"
                      placeholder="Select Port Name" v-model="moreAirportModel.fromAirport"></model-list-select>
                    <span class="error" v-if="!moreAirportModel.fromAirport">{{
                      errorMoreAirport.fromAirport
                      }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="55">
                    <label for="containerTypeId">To Location</label>
                    <model-list-select @input="getLocationList($event, 'Air_Port', 'toPortListTrans')" @searchchange="
                        getLocationList($event, 'Air_Port', 'toPortListTrans')
                      " option-value="pickupId" option-text="pickupLocation" :list="toPortListTrans"
                      placeholder="Select Port Name" v-model="moreAirportModel.toAirport"></model-list-select>
                    <span class="error" v-if="!moreAirportModel.toAirport">{{
                      errorMoreAirport.toAirport
                      }}</span>
                  </md-layout>
                </md-layout>

                <md-layout gutter class="labelMargtop">
                  <md-layout md-flex="40">
                    <md-layout md-flex="100">
                      <label>Flight Number</label>
                      <b-form-input :formatter="capitalizeAll" name="flightNumber" id="flightNumber"
                        v-model="moreAirportModel.flightNumber"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!moreAirportModel.flightNumber">{{
                      errorMoreAirport.flightNumber
                      }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label>Departure Date</label>
                    <date-picker :format="selectDateFormat" lang="en" id="dateDeparture" name="dateDeparture"
                      v-model="moreAirportModel.dateDeparture"></date-picker>
                    <span class="error" v-if="!moreAirportModel.dateDeparture">{{
                      errorMoreAirport.dateDeparture
                      }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Arrival Date</label>
                    <date-picker :format="selectDateFormat" lang="en" id="dateArrival1" name="dateArrival1"
                      v-model="moreAirportModel.dateArrival"></date-picker>
                    <span class="error" v-if="!moreAirportModel.dateArrival">{{
                      errorMoreAirport.dateArrival
                      }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="10" style="margin-top: 38px">
                    <b-button variant="info" size="sm" @click="addAirport" id="addButtonLoader1">{{
                      moreAirportModel.moreAirportId == "" ? "Add" : "edit"
                      }}
                      Airport</b-button>
                  </md-layout>
                </md-layout>
              </div>
              <div class="mt-3" v-if="tentativeDetailArrayList.length > 0">
                <h5>
                  <b-badge>Transhipment Details</b-badge>
                </h5>

                <!-- /.box-header -->
                <div>
                  <table id="ffBookingTentative" class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Flight No.</th>
                        <th>From Location</th>
                        <th>To Location</th>
                        <th>Arrival Time</th>
                        <th>Departure Time</th>
                        <!-- <th>Item Number</th> -->
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in tentativeDetailArrayList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.flightNumber }}</td>
                        <td>{{ item.fromAirportName }}</td>
                        <td>{{ item.toAirportName }}</td>
                        <td>{{ item.dateArrival | moment }}</td>
                        <td>{{ item.dateDeparture | moment }}</td>

                        <td>
                          <md-button class="md-icon-button md-raised md-dense" @click="viewEdit(item, index)">
                            <md-icon>edit</md-icon>
                          </md-button>
                        </td>
                        <td>
                          <md-button class="md-icon-button md-raised md-dense" @click="DeleteList(item, index)">
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
            </b-card>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="30">
                <b-button class="mt-3" variant="primary" @click="addBookingDetail" id="addButtonLoader1">Save & Proceed
                  To Execution</b-button>
                <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop2"
      @close="onClose"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/airFreightBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      isLoading: false,
      bookingShipmentName: [
        {
          bookingShipmentVal: "yes",
          bookingShipmentText: "Yes",
        },
        {
          bookingShipmentVal: "no",
          bookingShipmentText: "No",
        },
      ],
      value12: "",
      getCLientData: ["gfdg"],
      allShipperData: ["yhh"],
      hawbModal: {
        airBookingId: "",
        moreHawbId: "",
        shipperFreightId: "",
        clientName: "",
        HAWBNumber: "",
        HAWBDate: "",
      },
      errorHawbModal: {
        shipperFreightId: "",

        HAWBNumber: "",
        HAWBDate: "",
      },
      arrayErrorHawbModal: {
        shipperFreightId: "Select Shipper Name",

        HAWBNumber: "Enter HAWB Number",
        HAWBDate: "Enter HAWB Date",
      },
      BookingShippingLine: {
        airBookingId: "",
        allModuleId: "",
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),
        airLine: "",
        assignmentNumber: "",
        clientName: "",
        IATAAgent: "",
        bookingDate: "",
        MAWBNumber: "",
        MAWBDate: "",
        HAWBNumber: "",
        HAWBDate: "",
        fromAirport: "",
        toAirport: "",
        flightNumber: "",
        dateDeparture: "",
        dateArrival: "",
        bookingShipment: "",
      },

      errorArrayBookingShippingLine: {
        airLine: "Select Airine Name",

        IATAAgent: "Select Agent",
        bookingDate: "Select Booking Date",
        MAWBNumber: "Enter MAWB Number",
        MAWBDate: "Select MAWB Date",

        fromAirport: "Select From Location",
        toAirport: "Select To Location",
        flightNumber: "Enter Flight Number",
        dateDeparture: "Select Departure Date",
        dateArrival: "Select Arrival Date",
        bookingShipment: "Select Booking Shipment",
      },
      mawbError: "",
      errorBookingShippingLine: {
        airFreightBookingId: "",
        airLine: "",
        assignmentNumber: "",
        IATAAgent: "",
        bookingDate: "",
        MAWBNumber: "",
        MAWBDate: "",

        fromAirport: "",
        toAirport: "",
        flightNumber: "",
        dateDeparture: "",
        dateArrival: "",
        bookingShipment: "",
      },
      //  tentativePortNameFull: {},
      portMasterList: [],
      fromPortListTrans: [],
      toPortListTrans: [],
      fromPortList: [],
      toPortList: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      airFreightModel: {},
      blRegexError: "",
      houseRegexError: "",

      moreAirportModel: {
        actualDateArrival: "",
        actualDateDeparture: "",
        moreAirportId: "",
        fromAirport: "",
        toAirport: "",
        flightNumber: "",
        dateDeparture: "",
        dateArrival: "",
      },
      errorMoreAirport: {
        fromAirport: "",
        toAirport: "",
        flightNumber: "",
        dateDeparture: "",
        dateArrival: "",
      },
      arratErrorAirport: {
        fromAirport: "Select From Location",
        toAirport: "Select To Location",
        flightNumber: "Enter Flight Number",
        dateDeparture: "Select Departure Date",
        dateArrival: "Select Arrival Date",
      },
      tentativeDetailArray: [],
      HAWBArray: [],
      agentMasterList: [],
      airMasterList: [],
      deleteId: "",
      validateTrans: true,
      arrayError: [
        "Enter your tentative port Name",
        "Select ETA Date",
        // "Select ETA time",
        "Select ETA Date",
        // "Select ETD time"
      ],
      showAddAirport: false,
      errorBooking: {
        bookingNumber: "",
        validityBookingDate: "",
        SICutOff: "",
        bookingShipment: "",
      },
      bookingLengthError: "",
      arrayBookingError: [
        "Enter Booking Number",
        "Enter Validity Booking Number",
        "Enter SI Cut off",
        "Select Booking Shipment",
      ],
      editIndex: "",
      lastTrapArray: "",
      lastTransID: false,
    };
  },

  mounted() {},
  watch: {
    hawbModal: {
      handler: function (newVal, oldVal) {
        if (this.hawbModal.shipperFreightId != "") {
          let arrayClentId = this.getCLientData.filter((x) => {
            return x.shipperFreightId == this.hawbModal.shipperFreightId;
          });

          if (arrayClentId.length > 0) {
            this.hawbModal.clientName = arrayClentId[0].clientName;
          }
        }
      },

      deep: true,
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    BannerComponent,
    CustomLoader,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },

    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    },
  },
  methods: {
    codeAndNameAndDesc1(item) {
      return `${item.airlineName} - ${item.digitCode}`;
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    showAddAirportmet() {
      if (this.showAddAirport == false) {
        this.showAddAirport = true;
      } else {
        this.showAddAirport = false;
      }
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    autoENSDate() {
      this.BookingShippingLine.SICutOff = this.BookingShippingLine.ENSCutDate;
    },
    onClose() {
      this.$router.push({
        path: "/airfreight/airFreightExecution",
      });
      // if (this.BookingShippingLine.stuffingType == "factoryStuffing") {
      //   this.$router.push({
      //     path: "/freightForward/ffExecution"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffexecutionWareHouse"
      //   });
      // }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "air_booking_multiple_airport",
          tableId: "moreAirportId",
          // isActive: "isDepartmentActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },

    viewEdithawb(item) {
      Object.keys(this.hawbModal).map((x) => {
        this.hawbModal[x] = item[x] || "";
      });

      // this.tentativePortNameFull = this.portMasterList.filter(x => {
      //   return x.pickupId == this.TranshipmentDetail.tentativePortId;
      // })[0];
    },
    containerNoRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");
      let arrayLen = [];

      if (this.BookingShippingLine.shipmentExecution == "AirFreight") {
        if (blformat.test(this.BookingShippingLine.MAWBNumber)) {
          this.blRegexError = "";
        } else {
          this.blRegexError = "Enter Valid Format";
        }
      }
    },

    houseNoRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");

      if (blformat.test(this.hawbModal.HAWBNumber)) {
        this.houseRegexError = "";
      } else {
        this.houseRegexError = "Enter Valid Format";
      }
    },

    viewEdit(item, index) {
      this.showAddAirport = true;

      Object.keys(item).map((x) => {
        this.moreAirportModel[x] = item[x];
      });
    },
    DeleteList(item, index) {
      this.deleteId = item.moreAirportId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    previousAir() {
      this.$router.push({
        path: "/airFreight/airFFExportConsol",
      });
    },
    validateTranshipment() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.TranshipmentDetail[x] == "") {
          this.errorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    validateHAWB() {
      let validate_new = true;
      Object.keys(this.errorHawbModal).map((x, index) => {
        if (this.hawbModal[x] == "") {
          this.errorHawbModal[x] = this.arrayErrorHawbModal[x];
          validate_new = false;
        }
      });

      var blformat = new RegExp("^[0-9]{11}$");

      if (blformat.test(this.hawbModal.HAWBNumber)) {
        this.blRegexError = "";
      } else {
        this.blRegexError = "Enter Valid Format";
        validate_new = false;
      }
      if (this.BookingShippingLine.MAWBNumber == "") {
        $("#MAWBNumber").focus();
        this.mawbError = "Enter MAWB Number ";
        validate_new = false;
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    onFileChangeCargo() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editExportFCLId"),
        },
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaExport/UploadFFBooking.php`, formData, config)
        .then((result) => {
          this.BookingShippingLine.uploadBooking = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    addBookingDetail() {
      this.BookingShippingLine["transhipmentDetail"] = this.tentativeDetailArray;

      // return false;
      this.validateBooking();

      if (this.validateTrans != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: "fdsfdsf",
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addBookingDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              this.BookingShippingLine.airBookingId = data.airBookingId;
              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (this.BookingShippingLine.airBookingId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$refs["addPop2"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    validateBooking() {
      let validate_new = true;

      var blformat = new RegExp("^[0-9]{11}$");

      if (this.BookingShippingLine.shipmentExecution == "AirFreight") {
        if (blformat.test(this.BookingShippingLine.MAWBNumber)) {
          this.blRegexError = "";
        } else {
          this.blRegexError = "Enter Valid Format";
          validate_new = false;
          window.scroll(0, 50);
        }
      }
      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.errorArrayBookingShippingLine[x];
          validate_new = false;
        }
      });

      if (
        this.BookingShippingLine.bookingShipment == "yes" &&
        this.tentativeDetailArray.length == 0
      ) {
        this.bookingLengthError = "Select Atleast one transhipment";
        validate_new = false;
      } else {
        this.bookingLengthError = "";
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    validateAddAirport() {
      let validate_new = true;

      Object.keys(this.errorMoreAirport).map((x, index) => {
        if (this.moreAirportModel[x] == "") {
          this.errorMoreAirport[x] = this.arratErrorAirport[x];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addHawbDetails() {
      this.validateHAWB();

      if (this.validateTrans == true) {
        let newData = {
          moreHawb: this.hawbModal,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: "",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addHawbDetails.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              this.BookingShippingLine.airBookingId = data.airBookingId;
              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);

              Object.keys(this.hawbModal).map((x) => {
                this.hawbModal[x] = "";
              });
              Object.keys(this.errorHawbModal).map((x) => {
                this.errorHawbModal[x] = "";
              });
              this.mawbError = "";
              //   this.showAddAirport = false;
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    addAirport() {
      this.validateAddAirport();
      if (this.validateTrans != false) {
        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: "",
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addBookingDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              this.BookingShippingLine.airBookingId = data.airBookingId;
              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);

              Object.keys(this.moreAirportModel).map((x) => {
                this.moreAirportModel[x] = "";
              });
              Object.keys(this.errorMoreAirport).map((x) => {
                this.errorMoreAirport[x] = "";
              });
              this.showAddAirport = false;
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffBookingTentative").DataTable();
    //   });
    // },
    getData() {
      this.doLoading();
      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }
      let new_data = {
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),
        //ffExportFclId:,
        airBookingId:
          this.$sessionsStorage.get("editAirBookingId") != "" &&
          this.$sessionsStorage.get("editAirBookingId") != undefined
            ? this.$sessionsStorage.get("editAirBookingId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/viewAirBooking.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.agentMasterList = data.allAgent;
            this.airMasterList = data.airLineDetail;
            console.log("data.ffBookingDetail=>", data.ffBookingDetail);
            console.log("data.editFFEX=>", data.editFFEX);
            if (data.ffBookingDetail.length > 0) {
              Object.keys(this.BookingShippingLine).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
              this.BookingShippingLine.allModuleId = data.editFFEX[0].allModuleId;
              this.BookingShippingLine.shipmentExecution =
                data.editFFEX[0].shipmentExecution;
            } else {
              this.BookingShippingLine.assignmentNumber =
                data.editFFEX[0].airFFExportSeries;
              this.BookingShippingLine.fromAirport = data.editFFEX[0].airportDeparture;
              this.BookingShippingLine.toAirport = data.editFFEX[0].airportDestination;
              this.moreAirportModel.fromAirport = data.editFFEX[0].airportDeparture;
              this.BookingShippingLine.shipmentExecution =
                data.editFFEX[0].shipmentExecution;
            }

            Object.keys(data.editFFEX[0]).map((x) => {
              this.airFreightModel[x] = data.editFFEX[0][x];
            });
            if (data.editFFEX[0].airFFType == "fclNormal") {
              this.BookingShippingLine.clientName = data.clientData[0].clientName;
            }
            this.toPortListTrans = data.portLocationArray;
            this.fromPortListTrans = data.portLocationArray;
            this.toPortList = data.portLocationArray;
            this.fromPortList = data.portLocationArray;

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
              this.moreAirportModel.fromAirport = data.ffBookingTranshipment[0].toAirport;
              let lastTrans = this.tentativeDetailArray.slice(-1).pop();
              let arryTrans = [];
              arryTrans.push(lastTrans);
              this.lastTrapArray = arryTrans.filter((x) => {
                return x.toAirport == this.BookingShippingLine.toAirport;
              });
              console.log(this.lastTrapArray, "ioui");
              if (this.lastTrapArray.length > 0) {
                this.lastTransID = true;
              } else {
                this.lastTransID = false;
              }
            }
            if (data.clientData.length > 0) {
              this.getCLientData = data.clientData;
            } else {
              this.getCLientData = [];
            }
            if (data.shipperDetail.length > 0) {
              this.allShipperData = data.shipperDetail;
            } else {
              this.allShipperData = [];
            }
            if (data.hawbData.length > 0) {
              this.HAWBArray = data.hawbData;
            } else {
              this.HAWBArray = [];
            }
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// AirFreightBooking.vue?353aaffa